var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBox2 = function SvgIconBox2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#F6F6F6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.602 4.167 20.834 13.542v14.583L25.602 45.834 4.77 32.292V17.709L25.602 4.167ZM25.301 45.47V31.927",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.301 4.217 4.82 17.47l20.482 14.458L46.084 17.47 25.301 4.217Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.94 39.445V25.903M14.458 24.097v13.855M14.458 24.699 25 18.072 35.542 24.7",
    strokeLinecap: "round"
  }))));
};
export default SvgIconBox2;